import designViewReducer from '@configuratorware/configurator-frontendgui/App/Reducers/DesignView/Reducer';
import { RECEIVE_DESIGNER_DATA } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';

const query = new URLSearchParams(location.search);
const designSelection = JSON.parse(query.get('_designSelection'));

const replaceDesignViews = (state) => {
  if (state.designViews) {
    return state.designViews
      .map((view) => {
        view.designAreas = view.designAreas.filter(
          (area) =>
            !designSelection?.designAreas?.length ||
            designSelection?.designAreas?.some((selectedArea) => selectedArea.identifier === area.identifier)
        );
        return view;
      })
      .filter((view) => view.designAreas.length > 0);
  }
};
export default function (state, action) {
  switch (action.type) {
    case RECEIVE_DESIGNER_DATA: {
      const nextState = designViewReducer(state, action);
      if (designSelection && designSelection.designAreas) {
        const newDesignViews = replaceDesignViews(nextState);
        return {
          ...nextState,
          designViews: newDesignViews,
        };
      }
    }
  }
  return designViewReducer(state, action);
}
